import { combineReducers } from 'redux';
import navLayoutDimensionsState from '../NavLayoutDimensions/reducer';
import { navObjBuilderMenu, navObjBuilderMenuReducer } from '../components/ObjectCreateButton/reducer';
import overlayDisplayConfigState from '../overlayDisplayConfig/reducer';
import alerts from './Alerts';
import appConfig from './AppConfig';
import businessUnits from './BusinessUnits';
import experiments from './Experiments';
import { globalStylesReducer, globalStylesSliceName } from './GlobalStyles';
import onboardingProgress from './OnboardingProgress';
import portal from './Portal';
import portalAttributes from './PortalAttributes';
import translations from './Translations';
import user from './User';
import navItems from './navItems';
import portalUserAttributes from './portalUserAttributes';
import { inAppHelpReducer, inAppHelpSliceName } from '../external-contrib/in-app-help/reducers';
import { accountsDataReducer, accountsDataSliceName } from './AccountsData';
import { reducer as iaDetailsReducer, iaDetailsSliceName } from '../reducers/iaDetails.slice';
import { plpoExperienceReducer, plpoExperienceSliceName } from './PLPOExperience';
import { defaultHomeReducer, defaultHomeSliceName } from '../features/global-home-onboarding-tour/slices/default-home.slice';
import credits from './Credits';
export const rootReducer = combineReducers({
  navItems,
  portal,
  user,
  businessUnits,
  translations,
  portalAttributes,
  portalUserAttributes,
  experiments,
  onboardingProgress,
  appConfig,
  alerts,
  overlayDisplayConfigState,
  navLayoutDimensionsState,
  credits,
  [iaDetailsSliceName]: iaDetailsReducer,
  [globalStylesSliceName]: globalStylesReducer,
  [navObjBuilderMenu]: navObjBuilderMenuReducer,
  [inAppHelpSliceName]: inAppHelpReducer,
  [accountsDataSliceName]: accountsDataReducer,
  [plpoExperienceSliceName]: plpoExperienceReducer,
  [defaultHomeSliceName]: defaultHomeReducer
});